import { Analytics } from "@vercel/analytics/react"
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Perf } from 'r3f-perf'
import { StrictMode, Suspense } from 'react'

import Loader from './Components/Loader.jsx'
import App from './App.jsx'
import './index.css'

console.log("👋 Hi! If you notice a bug, please contact me: alessio.angioli0@gmail.com")

const isMobile = () => {
  return (window.innerWidth <= 1000) && (window.innerHeight <= 800)
}

const root = ReactDOM.createRoot(document.querySelector('#root'))

const fovForMobile = 100
const fovForPc = 45

root.render(
  <StrictMode>
    <Canvas
      camera={{
        fov: isMobile() ? fovForMobile : fovForPc,
        near: 0.1,
        far: 200,
        position: [52, 7, 12],
      }}
    >
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>

      {/* <Perf position="top-left" /> */}
    </Canvas>

    <Analytics />

    <div style={{ display: "none" }}>
      <section aria-hidden="true">
        <h1>LANGIO - Creative Developer</h1>
        <h2>Computer Enthusiast since day one</h2>
        <h2>Expert In Deepening My Every Curiosity</h2>
        <h2>Specialized in 3D/2D Web Development and Web3 Ecosystem</h2>
      </section>

      <section aria-hidden="true">
        <h2>Skills and Expertise</h2>
        <ul>
          <li>Three.js Developer</li>
          <li>React Developer</li>
          <li>Blender Developer</li>
          <li>3D Web and Web3 Experiences</li>
          <li>Creative Coding</li>
          <li>Figma Designer</li>
          <li>Canva Creator</li>
        </ul>
      </section>

      <section aria-hidden="true">
        <p>
          Welcome to the 3D portfolio of <strong>LANGIO</strong>. 
          This immersive portfolio was created using React Three Fiber and GSAP, 
          with custom 3D models designed in Blender. 
          Explore innovative web experiences that merge creativity and technology.
        </p>
      </section>

      <noscript>
        <p>
          This 3D portfolio of <strong>LANGIO</strong> showcases creative web development 
          using React Three Fiber, Three.js, and GSAP. 
          Please enable JavaScript to explore the immersive experience.
        </p>
      </noscript>
    </div>
  </StrictMode>
)
